import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BingLayer, GeocodingService, MapService } from '@ztarmobile/zwp-services-util';
import * as L from 'leaflet';
import { SHOP_ROUTE_URLS, ACTIVATION_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS} from '../../app.routes.names';
import { MetaService } from '../../../services/meta-service.service';

@Component({
  selector: 'app-coverages',
  templateUrl: './coverages.component.html',
  styleUrls: ['./coverages.component.scss']
})
export class CoveragesComponent implements OnInit {
  public zipCodeParam: string;
  public readMore = false;
  public coverageChecked = false;
  constructor(private mapService: MapService, private geocoder: GeocodingService,
              private router: Router, private route: ActivatedRoute,
              private metaService: MetaService) {
    this.zipCodeParam = this.route.snapshot.paramMap.get('zipCode');
    if (!!this.zipCodeParam) {
      this.coverageChecked = true;
    }
  }

  ngOnInit(): void {
    this.metaService.createCanonicalUrl();
   
  }

  public updateStatus($event): void {
    this.coverageChecked = $event;
  }

  public goToplans(): void {
   this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
  }
  public goTocheckCompatibility(): void {
   this.router.navigate([`${ACTIVATION_ROUTE_URLS.BASE}/${ACTIVATION_ROUTE_URLS.CHECK_PHONE}`]);
  }
}

